module.exports = __webpack_public_path__ + "img/background030.jpg";